/**
 * This is a small utility function that checks if the media is a lottie animation
 */ const isLottieJson = (url)=>typeof url === 'string' && /\.json$/.test(url);

export { isLottieJson };
